var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.$t('common.disableDuringPeriods'),"items":_vm.duringItems,"name":_vm.name,"multiple":""},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }